import type {
  GoodsRenderModel,
  GoodsCoreModel,
  IScreensLogging,
  PrimaryCardModel,
} from '../../../../api/types';

export type GoodsCardEntity = {
  type?: 'GOODS_CARD';
  item: GoodsCoreModel;
  logging: IScreensLogging;
  render?: GoodsRenderModel;
};

export type PrimaryCardEntity = {
  type: 'PRIMARY_CARD';
  item: PrimaryCardModel;
  logging: IScreensLogging;
};

export const isGoodsCard = (entity: CardEntity): entity is GoodsCardEntity => {
  return entity.type === 'GOODS_CARD';
};

export const isPrimaryCard = (entity: CardEntity): entity is PrimaryCardEntity => {
  return entity.type === 'PRIMARY_CARD';
};

export type CardEntity = GoodsCardEntity | PrimaryCardEntity;
